/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-formatting-rotate-counterclockwise-alt-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M8.75 17.5V10c0-.69.56-1.25 1.25-1.25h7.5c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25H10c-.69 0-1.25-.56-1.25-1.25zm-7.5-8.125l.881-.881 1.619 1.612V6.875A4.38 4.38 0 018.125 2.5h3.125v1.25H8.125A3.129 3.129 0 005 6.875v3.231l1.619-1.612.881.881L4.375 12.5 1.25 9.375z"/>'
  }
})
